import React from 'react';
import PropTypes from 'prop-types';

import Message from 'components/Message';
import { schedulePropTypes } from 'constants/propTypes';
import { bem } from 'helpers/class-name';

import AllBookingsSection from './AllBookingsSection';
import AllBookingsStatCard from './AllBookingsStatCard';
import ClassPassBookingsCard from './ClassPassBookingsCard';
import messages from './ScheduleDetailV2.messages';
import './BookingOverview.scss';

const { block, element } = bem('booking-overview');

const BookingOverview = ({ onViewInsights, schedule }) => {
  const { hasIntegrationData } = schedule;

  return (
    <section className={block()} data-cypress="booking-overview">
      <Message as="h3" className={element('title')} message={messages.bookingOverviewTitle} />
      <div className={element('cards')}>
        <ClassPassBookingsCard schedule={schedule} />
        {hasIntegrationData && <AllBookingsStatCard schedule={schedule} />}
      </div>
      <AllBookingsSection onViewInsights={onViewInsights} schedule={schedule} />
    </section>
  );
};

BookingOverview.propTypes = {
  onViewInsights: PropTypes.func,
  schedule: PropTypes.shape(schedulePropTypes).isRequired,
};

export default BookingOverview;
